import ModalBox from './ModalBox.vue'
import { events } from './events'

export default {
    reportIfNot: function (expectedType, argumentName, arg) {
        if ((expectedType === "object" && Array.isArray(arg)) || typeof arg !== expectedType) {
            let argumentType = typeof arg;

            if (Array.isArray(arg)) {
                argumentType = "array";
            }

            throw new Error(
                `${argumentName} type must be of type ${expectedType}. Caught: ${argumentType}. Expected: ${expectedType}`
            )
        }
    },

    install(Vue, args = {}) {
        Vue.component('v-modal-box', ModalBox);

        const modal = (message, confirmConfig, declineConfig = {}, showDeclineButton = true, dialogClass = '', declineOnClose = true) => {
            this.reportIfNot("string", "Message", message);

            this.reportIfNot("object", "Confirm config", confirmConfig);

            this.reportIfNot("function", "Callback in confirm config", confirmConfig.callback);

            if (typeof confirmConfig.name !== "undefined") {
                this.reportIfNot("string", "Button name in confirm config", confirmConfig.name);
            }

            this.reportIfNot("object", "Decline config", declineConfig);

            if (Object.keys(declineConfig).length !== 0) {
                if (typeof declineConfig.callback !== "undefined") {
                    this.reportIfNot("function", "Callback in decline config", declineConfig.callback)
                }

                if (typeof declineConfig.name !== "undefined") {
                    this.reportIfNot("string", "Button name in decline config", declineConfig.name);
                }
            }

            events.$emit('open', message, confirmConfig, declineConfig, showDeclineButton, dialogClass, declineOnClose);
        };

        modal.close = () => events.$emit('close');

        Vue.prototype.$modal = modal;
    }
};
